var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"default"},[_c('Header'),_c('portal-target',{attrs:{"name":"popup-gallery"}}),_c('Cookies'),_c('responsive-layout')],1)}
var staticRenderFns = []

export { render, staticRenderFns }